<template>
  <v-dialog v-model="dialog" persistent width="750">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>done</v-icon>Finalización de programación
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout>
              <v-flex xs12>
               
               
                    <h4>
                      <strong>Hoja de ruta:</strong> {{ form.comprobante2 }}
                    </h4>
                  </v-flex>
                </v-layout>
        
            <v-layout>
                  <v-flex>
                    <h4>
                      <strong>Fecha de finalización :</strong>
                      {{ form.fecha_fin }}
                    </h4>
                  </v-flex>
            </v-layout>
             <v-layout>
              <v-flex xs12>
                <h4><strong>Usuario :</strong> {{ 'Personal de recursos humanos' }}</h4>
                    
                
              </v-flex>
            </v-layout> 
            <v-layout>
              <v-flex xs12>
                <v-btn color=rgb(80,38,217) dark @click="descargarDocumento(form.ruta)"
            ><v-icon>picture_as_pdf</v-icon>
            Documento de respaldo
          </v-btn>
              </v-flex>
            </v-layout>

            
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.prevent="close()" :loading="loading"
            ><v-icon>close</v-icon>
            CERRAR
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      listado_funcionarios: [],
      form: {},
      valid: false,
      loading: false,
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      user: this.$storage.get("user"),
      fecha_desde: "",
      fecha_hasta: "",
      persona: null,
      saldo: null,
      periodo: null,
      id: null,
      id_programacion: null,
      headers: [
        { text: "Nombre", sortable: false, align: "center" },
        { text: "Dependencia", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
      ],
      bandera_aprobacion: true,
    };
  },
  mounted() {
    this.$bus.$on(
      "openDialogInformacionProgramacionDelMinisterio",
      async (item) => {
        this.form = item;
        this.form.comprobante = null;
        await this.cargarListadoFuncionario();
        this.dialog = true;
      }
    );
  },

  methods: {
    async cargarListadoFuncionario() {
      let res = [];
      let lista_funcionarios = [];
      this.listado_funcionarios = [];
      let user = this.$storage.get("user");
      try {

        res = await this.$service.graphql({
          query: `
							query{
							runQuery(consulta:"SELECT vacaciones.fn_valida_vacaciones_programadas_por_rrhh(${parseInt(
                this.form.gestion
              )})"){
								respuesta
							}
							}
						`,
        });
        res =
          res.runQuery.respuesta[0].fn_valida_vacaciones_programadas_por_rrhh;
        let res2 = res.split("|");
        let res3 = res.split(";");
        res3.splice(res3.length - 1);
        if (res2[0] == "0") {
          for (let i = 0; i < res3.length; i++) {
            const element = res3[i];
            let element3 = {};
            let elemento1 = element.split("|");

            if (elemento1[0] == "0") {
              element3.unidad = elemento1[1];
              element3.nombre = elemento1[2];
              element3.id_estado = elemento1[3];
              element3.estado = elemento1[4];
            } else {
              element3.unidad = elemento1[0];
              element3.nombre = elemento1[1];
              element3.id_estado = elemento1[2];
              element3.estado = elemento1[3];
            }
            lista_funcionarios.push(element3);
          }
          this.bandera_aprobacion = false;
        } else {
          lista_funcionarios = [];
        }

        this.listado_funcionarios = lista_funcionarios;
      } catch (error) {
        console.log(error);
      }
    },
    descargarDocumento(url){
      let api_backend = process.env.API_URL.split('api/')
      console.log(api_backend[0]+url)
      window.open(api_backend[0]+url);
   
    },
  
    close() {
      this.listado_funcionarios = [];
      this.loading = false;
      this.valid = false;
      this.dialog = false;
      this.$bus.$emit(
        "closeDialogInformacionFinalizarProgramacionesDelMinisterio"
      );
   
    },

    async finalizarProgramacion() {
      let user = this.$storage.get("user");
      let respuesta;
      let resps = [];
      let correcto = true;
      this.loading = true;

      try {
        respuesta = await this.$service.graphql({
          query: `query{
              runQuery(consulta:"select vacaciones.fn_finaliza_vacacion_programada_por_rrhh(${parseInt(
                this.form.gestion
              )},${parseInt(user.id)},'${this.form.comprobante}')"){
                respuesta
              }
            }
          `,
        });
        respuesta =
          respuesta.runQuery.respuesta[0]
            .fn_finaliza_vacacion_programada_por_rrhh;
        resps = respuesta.split("|");
        correcto = resps[0];
        if (correcto == "1") {
          this.$message.success(
            "Las programaciones del ministerio fuerón finalizadas exitosamente"
          );
        } else {
          this.$message.error(resps[1]);
        }
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
      this.close();
    },
  },
};
</script>

<style>
.ayuda {
  background: #7ae4db8f;
}



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/dialogs/InformacionProgramacionDelMinisterio.vue